<template>
  <container-black-x class="container md-elevation-6">
    <section class="pt-4 pb-4">
      <div class="row">
        <header class="col-sm-12 text-white">
          <h1 class="m-0 md-headline font-weight-bolder">Sua Conexão</h1>
          <h5 class="md-subheading m-0">Teste e entenda como funciona a sua internet</h5>
        </header>
      </div>
      <div class="row mt-4">
        <div class="col-12 col-lg-12" @click="showDialog = true">
          <widget-icon-on-circle
              titulo="Teste de Velocidade"
              :bg-img="require('../assets/background/bg_high_way_red_square.jpg')"
              :icon="require('../assets/icon/for_square_icon_speedometer.png')"
          ></widget-icon-on-circle>
        </div>
        <!-- <div class="col-12 col-lg-6" @click="linkExterno('https://ping.eu/ping')">
          <widget-icon-on-circle
              titulo="Teste de Ping"
              :bg-img="require('../assets/background/bg_server_azul_square.jpg')"
              :icon="require('../assets/icon/for_square_icon_host_secure.png')"
          ></widget-icon-on-circle>
        </div> -->
      </div>
    </section>
    <md-dialog :md-active.sync="showDialog" md-theme="black">
      <md-dialog-title>Testes de Conexão</md-dialog-title>
      <md-dialog-content>
        <div class="container-fluid">
          <div class="row mb-4 mt-2">
            <div class="col-12 d-flex justify-content-center">
              <img @click="linkExterno('http://www.minhaconexao.com.br/')"
                class="rounded pointer md-elevation-6" src="../assets/misc/minha_conexao.jpg" alt="Minha Conexão">
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <img @click="linkExterno('https://teste.virtex.com.br')"
                class="rounded pointer md-elevation-6" src="../assets/misc/speedtest.jpg" alt="Minha Conexão">
            </div>
            <div class="col-6">
              <img @click="linkExterno('https://fast.com/pt/')"
                class="rounded pointer md-elevation-6" src="../assets/misc/fast_com.jpg" alt="Minha Conexão">
            </div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Fechar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </container-black-x>
</template>

<script>
import ContainerBlackX from "./ContainerBlackX";
import WidgetIconOnCircle from "./WidgetIconOnCircle";
export default {
  name: "ConexaoBox",
  components: { WidgetIconOnCircle, ContainerBlackX },
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    linkExterno(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style scoped>
a:hover {
  text-decoration: none;
}
.pointer {
  cursor: pointer;
}
</style>
